export const ADD_ADMIN_QUESTION_REQUEST = " ADD_ADMIN_QUESTION_REQUEST";
export const ADD_ADMIN_QUESTION_SUCCESS = " ADD_ADMIN_QUESTION_SUCCESS";
export const ADD_ADMIN_QUESTION_FAILURE = " ADD_ADMIN_QUESTION_FAILURE";
